
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MEDIATHEK_UPCOMING"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leagues"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"multileague"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"leagues"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leagues"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"league"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shortcode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"upcoming"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"away_team"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"home_team"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"formattedDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"matchId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"matchThumbnail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"round"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isLiveGame"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isLiveNow"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cancelled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"matchId"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":297}};
    doc.loc.source = {"body":"query MEDIATHEK_UPCOMING($leagues: [String]!) {\n  multileague(leagues: $leagues) {\n    league\n    shortcode\n    upcoming {\n      away_team\n      home_team\n      formattedDate\n      matchId\n      matchThumbnail\n      round\n      isLiveGame\n      isLiveNow\n      cancelled\n      matchId\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["MEDIATHEK_UPCOMING"] = oneQuery(doc, "MEDIATHEK_UPCOMING");
        
